const Activation = () => import("@/modules/activation/pages/Activation.vue");
const Start = () => import("@/modules/activation/pages/Start.vue");
const Company = () => import("@/modules/activation/pages/Company.vue");
const Billing = () => import("@/modules/activation/pages/Billing.vue");
const SelectPlan = () => import("@/modules/activation/pages/SelectPlan.vue");
const Congratulations = () =>
  import("@/modules/activation/pages/Congratulations.vue");
const AddCreditCard = () =>
  import("@/modules/subscriptions/pages/AddCreditCard.vue");

export default [
  {
    path: "/activation",
    component: Activation,
    children: [
      {
        path: "",
        name: "start-activation",
        component: Start,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/activation/company",
        name: "company-info",
        component: Company,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/activation/billing",
        name: "billing",
        component: Billing,
        meta: {
          authRequired: true,
        },
      },
      {
        path: "/activation/select-plan",
        name: "select-plan",
        component: SelectPlan,
        meta: {
          authRequired: true,
        },
        children: [
          {
            path: "/activation/select-plan/addCreditCardForActivation",
            name: "addCreditCardForActivation",
            component: AddCreditCard,
            meta: {
              authRequired: true,
            },
          },
        ],
      },
      {
        path: "/activation/congratulations",
        name: "congratulations",
        component: Congratulations,
        meta: {
          authRequired: true,
        },
      },
    ],
    meta: {
      authRequired: true,
    },
  },
];
